import { render } from "./LinkIcon.vue?vue&type=template&id=15f958f8"
import script from "./LinkIcon.vue?vue&type=script&lang=js"
export * from "./LinkIcon.vue?vue&type=script&lang=js"
script.render = render

export default script